import { t } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

import { Confirmation, Table, Visible, withSelectionPanel } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { ButtonType, SelectionOptions, Size } from 'coreOld/enums';
import { IFiltersProps, ISelectionPanelProps } from 'coreOld/types';
import AddCostNote from 'partsOld/components/AddCostNote';
import { IPart, ISelectedNote } from 'partsOld/types';

const getConfirmationTitle = (isMultiple: boolean) =>
  isMultiple ? t('labelRemoveParts') : t('labelRemovePart');

const getConfirmationMessage = (
  selectedRows: IPart[],
  selectionMode: SelectionOptions,
  filteredCount: number
) => {
  const partsLength =
    selectionMode === SelectionOptions.FILTERED ? filteredCount : selectedRows?.length;

  if (partsLength > 1) {
    return t('messageRemoveParts', {
      partsLength,
    });
  }

  return t('messageRemovePart');
};

interface IProps extends ISelectionPanelProps<IPart>, IFiltersProps {
  data: IPart[];
  tableColumns;
  filters: Record<string, any>;
  isLoading?: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  confirmationOption?: boolean;
  setConfirmationOption?: Dispatch<SetStateAction<boolean>>;
  setIsAddCostOpen?: Dispatch<SetStateAction<boolean>>;
  isAddCostOpen?: boolean;
  fetchNextPage;
  removeBulkCompanyParts;
  setCloseSelection: Dispatch<SetStateAction<boolean>>;
}

const CompanyPartsView = ({
  tableColumns,
  filters,
  data,
  setSelectedRows,
  onCheckboxClick,
  isModalOpen,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  confirmationOption,
  setConfirmationOption,
  selectedRows,
  removeBulkCompanyParts,
  setIsAddCostOpen,
  isAddCostOpen,
  setCloseSelection,
  selectionMode,
  filteredCount,
}: IProps) => {
  return (
    <>
      <Visible when={Boolean(confirmationOption)}>
        <Confirmation
          isOpen={Boolean(confirmationOption)}
          onConfirm={() => removeBulkCompanyParts(selectedRows)}
          onCancel={() => setConfirmationOption(false)}
          confirmBtnLabel={t('buttonLabelRemove')}
          confirmBtnType={ButtonType.DANGER}
          size={Size.MD}
          title={getConfirmationTitle(selectedRows?.length > 1)}
          message={getConfirmationMessage(selectedRows, selectionMode, filteredCount)}
        />
      </Visible>

      <AddCostNote
        setIsAddCostOpen={setIsAddCostOpen as Dispatch<SetStateAction<boolean | ISelectedNote>>}
        isAddCostOpen={isAddCostOpen}
        selectedItems={selectedRows}
        setCloseSelection={setCloseSelection}
        companyPartFilters={filters}
      />

      <Table
        columns={tableColumns}
        data={data}
        name={TableNames.COMPANY_PARTS}
        setSelectedRows={setSelectedRows}
        onCheckboxClick={onCheckboxClick}
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        alternating={false}
        borderBottom
        hasRowSelection
        hasFilters
        showInfoIcon
        selectMenuOptions={[SelectionOptions.DISPLAYED, SelectionOptions.FILTERED]}
        hasBigSubheader
      />
    </>
  );
};

export default withSelectionPanel(CompanyPartsView);
